"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.rotateElement = rotateElement;
var _operations = require("./_operations");
/*************************************************************
                      TRANSFORMS
**************************************************************/

// https://stackoverflow.com/a/64875432
// https://longviewcoder.com/2020/12/15/konva-rotate-a-shape-around-any-point/
function rotatePoint(point, deg) {
  var rad = (0, _operations.degToRad)(deg || 0);
  var rcos = Math.cos(rad);
  var rsin = Math.sin(rad);
  return {
    x: Math.round(point.x * rcos - point.y * rsin),
    y: Math.round(point.x * rsin + point.y * rcos)
  };
}
function rotateAroundPoint(shape, rotateBy, point) {
  var dxdy = {
    x: shape.x - point.x,
    y: shape.y - point.y
  };

  // rotation-in-place
  var rotated = rotatePoint(dxdy, rotateBy);

  // followed by a translation (or move)
  var translated = {
    x: point.x + rotated.x,
    y: point.y + rotated.y
  };
  return translated;
}

/*************************************************************
                      KONVA TRANSFORMS
**************************************************************/
function rotateElement(el, deg, origin) {
  var _origin;
  var boundingBox = el.getClientRect();
  var shape = {
    x: el.x(),
    y: el.y(),
    width: boundingBox.width,
    height: boundingBox.height
  };

  // use shape center if origin not provided
  origin = (_origin = origin) !== null && _origin !== void 0 ? _origin : (0, _operations.getRelativeCenter)(shape);

  // compute degree offset to rotate
  var moveBy = (0, _operations.getRelativeRotation)(el.rotation(), deg);
  var position = rotateAroundPoint(shape, moveBy, origin);
  var absolute_rotation = el.rotation() + moveBy;
  el.setAttrs({
    position: position,
    rotation: absolute_rotation % 360
  });
}